/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Card, CardContent, FormControl, Grid, InputAdornment, InputLabel, MenuItem, Select, TextField, } from "@mui/material";
import { GridSearchIcon } from "@mui/x-data-grid";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import MDButton from "components/MDButton";
import DeleteModal from "components/deletemodal/deletemodal";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { deleteUserRecords, fetchUser } from "utils/api";
import { appConstants } from "utils/appConstants";
import { getScreenRight, showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import IconMenu from "components/CustomMaterialMenu/Custom";
import { useCallback } from "react";
import { use } from "react";

let searchParameter = "";
let userStatus = "Active";
let LOGIN_DETAILS;
let PLAN_DETAILS;
const SCREEN_NAME = "My Users";
let SCREEN_RIGHT;
function MyUsers() {
  //Starts here change the pagination text Rows per page to Record per page
  let changePaginationText = document.getElementsByClassName("rdt_Pagination")[0];
  if (changePaginationText !== undefined) {
    changePaginationText.getElementsByTagName('span')[0].textContent = "Records Per Page";
  }
  //ends here change the pagination text Rows per page to Record per page
  const [customerReload, setCustomerReload] = useState(false);
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const [rows, setRows] = useState([]);
  const [controller] = useMaterialUIController();
  const { sidenavColor, darkMode } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [title, setTitle] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [screenAccess, setScreenAccess] = useState(false);
  const dispatch = useDispatch();

  const [values, setValues] = useState({

    _id: [],
    sortingType: "",
    sortingField: "",
    userStatus: "All",
    page: appConstants.page,
    limit: appConstants.limit,
    fromDate: "",
    toDate: "",
    filterValues: "",
    searchParameter: "",
    searchParameterList: ['fullNameString', 'userStatus', 'role', 'userType', 'emailAddress'],
    businessUserID: JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'))?.businessUserID,
    userID: JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'))?._id,
  });


  if (sessionStorage.getItem('LOGIN_DETAILS') !== undefined && sessionStorage.getItem('LOGIN_DETAILS') != null) {
    LOGIN_DETAILS = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'));
    values.businessUserID = LOGIN_DETAILS.businessUserID;
    values.userID = LOGIN_DETAILS._id;
  }

  if (sessionStorage.getItem('PLAN_DETAILS') !== undefined && sessionStorage.getItem('PLAN_DETAILS') != null) {

    PLAN_DETAILS = JSON.parse(sessionStorage.getItem('PLAN_DETAILS'));
  }

  useEffect(() => {
    (async () => {
      let duration = new URLSearchParams(window.location.search).get('duration');
      let customFrom = new URLSearchParams(window.location.search).get('from');
      let customTo = new URLSearchParams(window.location.search).get('to');
      duration && (values.durationDate = duration)
      customFrom && (values.fromDate = customFrom)
      customTo && (values.toDate = customTo)
      await getRight();
      await fetchUserData();
    })();
  }, [values.userStatus, values.sortingType, perPage, dispatch]);


  const handleCancel = (name) => (event) => {
    setDeleteDialogeFlag(false);
  };

  const handleDeleteDialogeClick = async (_id) => {
    if (LOGIN_DETAILS._id === _id) {
      showResMsg(genericMessage.logusercantdeleted, 2000, false);
      return
    }
    else if (PLAN_DETAILS[0].businessUserEmailID !== LOGIN_DETAILS.emailAddress) {
      showResMsg(genericMessage.notAuth, 1000, false);
      return
    }
    values._id = []
    values._id.push(_id)
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleDelete = async (id) => {
    deleteUser();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handlePageChange = page => {
    values.page = page;
    fetchUserData();

  };

  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
    await fetchUserData();
  };

  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
  };

  const deleteUser = async () => {
    await deleteUserRecords(values, (data) => {
      fetchUserData();
      setTitle("");
      showResMsg(data.Result_Status ? genericMessage.deleted : data.Result_Message, 1000, data.Result_Status);
    }, dispatch)
  };

  async function getRight() {
    let right = await getScreenRight("My Users")
    if (right === "Full Access") {
      setDisableColor(false)
      setScreenAccess(true);
    } else {
      setDisableColor(true)
    }
  }
  const changeCustomerReload = () => {
    setCustomerReload(!customerReload);
  };

  useEffect(() => {
    userStatus = values.userStatus;
    changeCustomerReload();
  }, [values.userStatus]);

  const fetchUserData = async () => {
    values.searchParameter = searchParameter;
    values.userStatus = userStatus;
    await fetchUser(values, (data) => {
      console.log("data", data)
      setTotalRows(data.Result_Output.totalDocs);
      setRows(data.Result_Output.docs)
    }, dispatch)
  };

  let columns = [
    {
      // name: "Name",
      name: <p style={{ fontSize: "12px" }}>Name</p>,
      // selector: row => row.fullNameString.fullName,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.fullNameString.fullName}</span>
      ),
      sortable: true,
      sortField: 'fullNameString.fullName',
      left: true,
    },
    {
      // name: "Email Address",
      name: <p style={{ fontSize: "12px" }} >Email Address</p>,
      // selector: row => row.emailAddress,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.emailAddress}</span>
      ),
      sortable: true,
      sortField: 'emailAddress',
      // style: { paddingLeft: "10px" },
      center: true,
    },
    {
      // name: "User Type",
      name: <p style={{ paddingLeft: "12px", fontSize: "12px" }}>User Type</p>,
      // selector: row => row.userType,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.userType}</span>
      ),
      sortable: true,
      sortField: 'userType',
      // style: { paddingLeft: "10px" },
      center: true,
    },
    {
      // name: "Role",
      name: <p style={{ paddingLeft: "12px", fontSize: "12px" }}>Role</p>,
      // selector: row => row.role,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.role}</span>
      ),
      sortable: true,
      sortField: 'role',
      // style: { paddingLeft: "10px" },
      center: true,
    },
    {
      // name: "Status",
      name: <p style={{ paddingLeft: "20px", fontSize: "12px" }}>Status</p>,
      // selector: row => row.userStatus,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.userStatus}</span>
      ),
      sortable: true,
      sortField: 'userStatus',
      // style: { paddingLeft: "10px" },
      center: true,
      cell: row => (
        <span
          style={{
            border: "1px solid black",
            color: "black",
            padding: "3px 3px",
            borderRadius: "2px",
            fontSize: "12px",
            fontWeight: 500,
            textTransform: "capitalize",
            display: "inline-block",
            minWidth: "60px",
            textAlign: "center",
          }}
        >
          {row.userStatus || "N/A"}
        </span>
      )
    },
    {
      // name: "Action(s)",
      name: <p style={{ fontSize: "12px" }}>Action(s)</p>,
      // selector: row => row._id,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row._id}</span>
      ),
      center: true,
      cell: row => <IconMenu size="small" row={
        <>
          {/* <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}> */}
          <Grid style={{ width: "100%" }} item>
            <Link
              to={`/myusers/edit/${row._id}`}
              disabled={!screenAccess}
            >
              <p style={darkMode ? { color: "white" } : { color: "black" }}>
                <TimelineItem color="success"
                  // icon="edit" 
                  icon={<EditIcon className="actionicon" />}
                  title="Edit" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit</p>
            </Link>
          </Grid>
          <Grid style={{ width: "100%" }} item >
            <p style={darkMode ? { color: "white" } : { color: "black" }} onClick={() => handleDeleteDialogeClick(row._id)} disabled={!screenAccess}>
              <TimelineItem
                color="error"
                // icon="delete"
                icon={<DeleteIcon className="actionicon" />}
                onClick={() => handleDeleteDialogeClick(row._id)}
                title="Delete"
              />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Delete</p>
          </Grid>
          {/* </Grid> */}
        </>
      } />,
    },
  ]

  const getSearchResult = useCallback(() => {
    fetchUserData();
  }, [values.filterValues]);

  useEffect(() => {
    // eslint-disable-next-line eqeqeq
    if (values.filterValues.length == "") {
      getSearchResult();

    }
  }, [values.filterValues]);

  return (
    <DashboardLayout>
      <DashboardNavbar screenName='My Users' />
      <div style={{ marginTop: '20px' }}>
        <Card color="primary" sx={{ paddingBottom: "10px" }}>
          <PageTitle screenName="My Users" />
          <Grid container display={"flex"} justifyContent="end" mt={2} gap={2}  >
            <Grid lg={2.5} xs={6} >
              <FormControl fullWidth>
                <InputLabel id="Status">Filter By Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "38.11px" }}
                  label="Filter By Status"
                  value={values.userStatus}

                  onChange={(e) => setValues({ ...values, userStatus: e.target.value })}
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid lg={2.5} xs={6}>
              <TextField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values.filterValues}
                onChange={handleSearchFilter}
                onKeyUp={(e) => { if (e.key === "Enter") fetchUserData() }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment  >
                      <Button style={{ borderRadius: "0px 0.5rem  0.5rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={fetchUserData}>
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <div style={{ marginRight: '16px' }}>
              {screenAccess ?
                <Link to={"/myusers/new"}>
                  <MDButton
                    variant="contained"
                    className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                    color={disableColor ? "secondary" : "success"}
                    style={{ height: "38.11px" }}
                  >
                    Add New
                  </MDButton>
                </Link>
                :

                <MDButton
                  variant="contained"
                  className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                  color="secondary"
                  style={{ height: "38.11px" }}
                >
                  Add New
                </MDButton>
              }
            </div>
          </Grid>
          {/* <CardContent> */}
          <BTable
            title={title}
            columns={columns}
            data={rows}
            selectableRows={false}
            sortingType={handleSort}
            sortServer
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            fixedHeaderScrollHeight="410px"
            fixedHeader={true}

          />
          {/* </CardContent> */}
        </Card>
      </div >

      <DeleteModal
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
      />

    </DashboardLayout >
  );
}

export default MyUsers;
